import React from 'react'
import TreeImages from '../page-specific/TreeImages'

export default class Home extends React.Component {

  componentWillMount() {
    if (this.props.content.selectedPage !== 'home') {
      this.props.changePage('home', 'centered')
    }
  }

  render() {
    return (
      <TreeImages
        images={this.props.content.home.images}
        imagesLoaded={this.props.imagesLoaded}
        imageLoad={this.props.imageLoad}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/Home.js